export { default as DonorHome } from './DonorHome'; 
export { default as DonationHistory } from './DonationHistory'; 
export { default as UpComingDonations } from './UpComingDonations'; 